import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Wrench } from 'lucide-react';
import BackgroundBlobs from '../components/BackgroundBlobs';

const MaintenancePage = () => (
  <main
    className="w-full min-h-screen min-h-[100dvh] relative overflow-hidden bg-white"
    data-testid="maintenance-screen"
  >
    <BackgroundBlobs />

    <div className="relative z-10 min-h-screen min-h-[100dvh] flex items-center justify-center px-5 py-10 sm:px-8">
      <motion.section
        className="w-full max-w-xl text-center"
        initial={{ y: 18, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 260, damping: 24 }}
        aria-labelledby="maintenance-title"
      >
        <p className="text-5xl sm:text-6xl font-bold text-gradient font-['Outfit'] mb-6">
          Harday
        </p>

        <div className="glass-panel rounded-[28px] px-6 py-8 sm:px-10 sm:py-10">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-[#9333EA]/10 via-[#EC4899]/10 to-[#0A9396]/10 ring-1 ring-[#9333EA]/15">
            <Wrench className="h-8 w-8 text-[#7C3AED]" aria-hidden="true" />
          </div>

          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-[#0A9396] font-['DM_Sans']">
            Temporary maintenance
          </p>
          <h1
            id="maintenance-title"
            className="text-3xl sm:text-4xl font-bold text-[#111111] font-['Outfit']"
          >
            Site Under Maintenance
          </h1>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#666666] font-['DM_Sans']">
            The site is currently under maintenance. Please wait while we complete the work.
          </p>

          <div className="mt-7 flex items-start gap-3 rounded-2xl border border-[#0A9396]/15 bg-[#0A9396]/[0.06] px-4 py-4 text-left sm:px-5">
            <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-[#0A9396]" aria-hidden="true" />
            <p className="text-sm sm:text-base leading-relaxed text-[#374151] font-['DM_Sans']">
              Your streak will be preserved during maintenance, so you don't need to worry about losing it.
            </p>
          </div>
        </div>
      </motion.section>
    </div>
  </main>
);

export default MaintenancePage;

